export const userConfirmationPath = "/confirmation";
